<template>
  <div class="home-wrapper">
    <div class="home-content">
      <p>I am excited to announce my second novel, sequel to my debut: The Cases of Inspector Marshall, Volume II.</p>
      <p>This dark fantasy detective anthology includes:</p>
      <p class="inset-list">1. Six major cases, including the conclusion to "The Hidden Archway."</p>
      <p class="inset-list">2. A seventh case, "The Man of Two Minds" split into three parts.</p>
      <p class="inset-list">3. Several vignettes, including: a prologue and epilogue; two folktales from the world; and two monster hunts by the detective.</p>
      <p class="inset-list">4. Various appendices, bonus content for worldbuilding, lore, and reference.</p>
      <p>Thanks to all reader, friends, family, and newcomers for your support.</p>
    </div>
    <div class="home">
      <section class="book">
      <div class="header-book-title">
        <div class="header-book-title-text">
          <p>
            The Cases of Inspector Marshall, Volume II
            <br />
            <span class="header-book-subtitle">Among the Archives of Astryss</span>
          </p>
        </div>
        <div class="header-book-title-img">
          <img src="@/assets/new-release-2.png" />
        </div>
      </div>
      <section class="header-book">
        <div class="header-book-image">
          <a
            href="https://www.amazon.com/Cases-Inspector-Marshall-II-Archives/dp/1958491039"
            target="_blank"
          >
            <img
              alt="The Cases of Inspector Marshall, Volume II: Among the Archives of Astryss"
              src="@/assets/inspector_marshall_vol2.jpeg"
            />
          </a>
        </div>
        <div class="header-book-synopsis">
          <p>A magical terrorist is on the loose. Murder strikes an airship party. A lumberjack, thought dead and cremated, kills and eats a lawyer during a national court case. In the city of Grousecap, a ritualistic serial killer has stalked the streets for sixty years. Inspector Archibald Marshall returns to solve these cases and more.</p>
          <p>Yet the land of Astryss becomes more dangerous each month. Marshall faces a growing number of magical threats, enduring close victories and bitter losses. And several of his problems trace back to a haunting surrounding three refugees from centuries prior.</p>
          <p>
            <a
              href="https://www.amazon.com/Cases-Inspector-Marshall-II-Archives-ebook/dp/B0B6JVQDX8"
              target="_blank"
              @click="clickedKindle('The Cases of Inspector Marshall, Volume II')"
            >Kindle</a> |
            <a
              href="https://www.amazon.com/Cases-Inspector-Marshall-II-Archives/dp/1958491039"
              target="_blank"
              @click="clickedPaperback('The Cases of Inspector Marshall, Volume II')"
            >Paperback</a>
          </p>
        </div>
      </section>
      </section>
      <section class="book">
      <div class="header-book-title">
        <div class="header-book-title-text">
          <p>
            The Cases of Inspector Marshall, Volume I
            <br />
            <span class="header-book-subtitle">Among the Archives of Astryss</span>
          </p>
        </div>
      </div>
      <section class="header-book">
        <div class="header-book-image">
          <a
            href="https://www.amazon.com/Cases-Inspector-Marshall-Archives-Astryss-ebook/dp/B0852QTXKT"
            target="_blank"
          >
            <img
              alt="The Cases of Inspector Marshall, Volume I: Among the Archives of Astryss"
              src="@/assets/inspector_marshall_vol1.jpeg"
            />
          </a>
        </div>
        <div class="header-book-synopsis">
          <p>A banker lies dead, heart devoured from his chest. A woman is found asphyxiated in a room locked from the inside. When the moons are full, those who enter a haunted wood end up decapitated. These are but a handful of cases that Inspector Archibald Marshall must solve.</p>
          <p>Monsters and spirits have returned to the continent of Astryss, terrorizing a land that has forgotten how to fight these threats. Marshall is one of the few trained to combat mythical creatures. In a world ripe with magic and powered by steam, the detective investigates cases mundane and mystic, battling demons from Hell and within his own heart.</p>
          <p>
            <a
              href="https://www.amazon.com/Cases-Inspector-Marshall-Archives-Astryss-ebook/dp/B0852QTXKT"
              target="_blank"
              @click="clickedKindle('The Cases of Inspector Marshall, Volume I')"
            >Kindle</a> |
            <a
              href="https://www.amazon.com/Cases-Inspector-Marshall-Archives-Astryss/dp/B0851LYCS1"
              target="_blank"
              @click="clickedPaperback('The Cases of Inspector Marshall, Volume I')"
            >Paperback</a>
          </p>
        </div>
      </section>
      </section>
    </div></div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  mounted() {
    this.$parent.$analytics.setCurrentScreen("home");
    this.$parent.$analytics.logEvent("page_view");
  },
  methods: {
    clickedKindle(volume) {
      this.$parent.$analytics.logEvent("view_item", {
        bookType: "kindle",
        series: "Among the Archives of Astryss",
        volume: volume
      });
    },
    clickedPaperback(volume) {
      this.$parent.$analytics.logEvent("view_item", {
        bookType: "paperback",
        series: "Among the Archives of Astryss",
        volume: volume
      });
    }
  }
};
</script>

<style lang="scss">
.home-wrapper {
  background-image: url("~@/assets/main-bg-1.jpg");
  /* Full height */
  //  height: 100%;
  padding-top: 200px;
  padding-bottom: 200px;

  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.home {
  margin-top: 20px;
  padding-top: 100px;
  padding-bottom: 100px;
  background-color: #34515e; //#cecece;
  color: white;
}

.book {
  margin-bottom: 10px;
  border-bottom: 1pt solid #607d8b;
}

.header-book {
  justify-content: center;
  align-items: stretch;
  display: flex;
  flex-direction: row;
  margin: 80px;
}
.header-book-image {
  flex-grow: 1;
  width: 250px;
  margin: auto;
}
.header-book-title {
  display: flex;
  flex-direction: row;
}
.header-book-subtitle {
  font-size: 20pt;
}
.header-book-title-text {
  font-size: 28pt;
  font-style: italic;
  margin: auto;
  flex-grow: 3;
}
.header-book-title-img {
  flex-grow: 1;
  margin: auto;
  width: 100px;
}
.header-book-synopsis {
  font-size: 16pt;
  flex-grow: 2;
  margin: auto;
  width: 250px;
  p {
    text-justify: justify;
    margin-bottom: 8px;
    margin-left: 18px;
    a {
      color: #ff9800;
    }
  }
}
.home-content {
  padding: 100px;
  margin: 0 auto;
  margin-bottom: 100px;
  text-align: left;
  font-size: 16pt;
  background-color: #607d8b;
  color: #ffffff;
  p {
    padding-left: 16px;
    padding-right: 16px;
  }
  .inset-list {
    padding-left: 32px;
  }
}

@media only screen and (max-width: 768px) {
  .home-content {
    padding: 12px;
    margin-bottom: 50px;
    font-size: 14pt;
  }
  .home-wrapper {
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .header-book-title {
    justify-content: center;
  }
  .header-book-subtitle {
    font-size: 12pt;
  }
  .header-book-title-text {
    font-size: 14pt;
  }
  .header-book-title-img {
    display: none;
  }
  .header-book {
    flex-direction: column;
    margin: 12px;
  }
  .header-book-synopsis {
    font-size: 10pt;
  }
}
</style>